import React from 'react'

import Button from 'devextreme-react/button'

import { usePrevious } from 'helpers/use-previous'

import './tabs.scss'

export type Tab = {
    name: string,
    icon?: string,
    disabled?: boolean,
}

type ITabsProps = {
    tabs: Tab[],
    onTabClick: (tabId: number) => void,
    activeTabIndex: number,
}

export const Tabs = ({ tabs, onTabClick, activeTabIndex }: ITabsProps) => {
    const lastTabIndex = usePrevious<number>(activeTabIndex)

    const onClick = (tabIndex: number) => {
        return (_: any) => {
            onTabClick(tabIndex)
        }
    }

    const tabsToMove = lastTabIndex !== undefined ? Math.abs(activeTabIndex - lastTabIndex) : activeTabIndex
    const lineAnimationLength = tabsToMove !== 0 ? 500 / tabsToMove : 0

    const getTransition = (tabIndex: number) => {
        const lti = lastTabIndex !== undefined ? lastTabIndex : 0
        if (lti < activeTabIndex) {
            if (tabIndex < lti || tabIndex > activeTabIndex) { return {} }

            return {
                transition: `all ${lineAnimationLength}ms ease-in-out ${(tabIndex - lti - 1) * lineAnimationLength}ms`
            }
        } else {
            if (tabIndex < activeTabIndex || tabIndex > lti) { return {} }

            return {
                transition: `all ${lineAnimationLength}ms ease-in-out ${(lti - tabIndex) * lineAnimationLength}ms`
            }
        }
    }

    return (
        <div className='tabs'>
            {
                tabs.map((tab, i) => (
                    <div
                        key={i}
                        className={`tabs--item ${i === activeTabIndex ? 'active' : ''} ${i < activeTabIndex ? 'passed' : ''}`}>
                        <div
                            className='tabs--item--before'
                            style={getTransition(i)}>
                        </div>

                        <div className='tabs--item--bullet'>
                            {
                                tab.icon
                                    ? (<Button icon={tab.icon} hint={tab.name} disabled={tab.disabled} onClick={onClick(i)} />)
                                    : (<Button stylingMode='text' text={tab.name} disabled={tab.disabled} onClick={onClick(i)} />)
                            }
                        </div>
                    </div>
                ))
            }
        </div>
    )
}
